import { CleanDataObject } from './createSearchParamsBrackets'
import { QueryParamValue } from '@components/Filters/filter.types'
import type { IsoDateRange } from '@lib/tz'

type FilterValue = QueryParamValue | QueryParamValue[] | IsoDateRange

export function normalizeFiltersToObject(filters: FilterValue): CleanDataObject {
  const allParams: CleanDataObject = {}

  Object.entries(filters).forEach(([key, value]) => {
    if (value && typeof value === 'object' && !Array.isArray(value) && ('from' in value || 'to' in value)) {
      const { from, to } = value as IsoDateRange

      if (from) {
        allParams[`${key}_from`] = from
      }
      if (to) {
        allParams[`${key}_to`] = to
      }
    } else if (value !== undefined && value !== null && value !== '' && (!Array.isArray(value) || value.length > 0)) {
      allParams[key] = value
    }
  })

  return allParams
}

export function formatArrayParamsWithBrackets(data: CleanDataObject): CleanDataObject {
  return Object.entries(data).reduce((acc, [key, value]) => {
    if (Array.isArray(value)) {
      acc[`${key}[]`] = value
    } else {
      acc[key] = value
    }

    return acc
  }, {} as CleanDataObject)
}
